/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CreateTablesFromGoldStandardResponse model module.
 * @module model/CreateTablesFromGoldStandardResponse
 * @version 2.8.0
 */
class CreateTablesFromGoldStandardResponse {
    /**
     * Constructs a new <code>CreateTablesFromGoldStandardResponse</code>.
     * @alias module:model/CreateTablesFromGoldStandardResponse
     * @param tableIds {Array.<String>} 
     */
    constructor(tableIds) { 
        
        CreateTablesFromGoldStandardResponse.initialize(this, tableIds);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, tableIds) { 
        obj['tableIds'] = tableIds;
    }

    /**
     * Constructs a <code>CreateTablesFromGoldStandardResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateTablesFromGoldStandardResponse} obj Optional instance to populate.
     * @return {module:model/CreateTablesFromGoldStandardResponse} The populated <code>CreateTablesFromGoldStandardResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateTablesFromGoldStandardResponse();

            if (data.hasOwnProperty('tableIds')) {
                obj['tableIds'] = ApiClient.convertToType(data['tableIds'], ['String']);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<String>} tableIds
 */
CreateTablesFromGoldStandardResponse.prototype['tableIds'] = undefined;






export default CreateTablesFromGoldStandardResponse;

